// src/features/vendor/vendorSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { fetchVendorMaster } from './vendorThunks';

const initialState = {
    vendors: [],
    loading: false,
    error: null,
};

const vendorSlice = createSlice({
    name: 'vendor',
    initialState,
    reducers: {
        // Add any sync reducers here if needed
        setVendors: (state, action) => {
            console.log(action,"action in vender masyere jnj")
            state.vendors = action.payload;
            state.loading = false;
            state.error = null;
        },
        setVendorLoading: (state) => {
            state.loading = true;
        },
        setVendorError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        resetVendor: () => initialState, // 🔁 Reset to initial state

    },



    // THIS FUNCTION USED FOR createAsyncThunk **REACT QUERY V5 IS BEST FOR createAsyncThunk **
    extraReducers: (builder) => {
        builder
            .addCase(fetchVendorMaster.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchVendorMaster.fulfilled, (state, action) => {
                state.loading = false;
                state.vendors = action.payload;
            })
            .addCase(fetchVendorMaster.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            });
    },
});

export const { setVendors, setVendorLoading, setVendorError, resetVendor } = vendorSlice.actions;
export default vendorSlice.reducer;
